/**
 * Shared Internationalization (i18n) - Common Labels
 * @module domains/shared/i18n
 * 
 * Contains common translations that are shared across all domain modules.
 * Each key contains an object with translations for pt, en, and es.
 * 
 * Usage:
 * import { i18n } from '@/domains/shared/i18n';
 * import { t } from '@/chassis/helpers/i18n';
 * 
 * const label = t(i18n, 'common.actions.save', 'pt'); // "Salvar"
 */

export const i18n = {
  // ==========================================
  // Common - Actions
  // ==========================================
  'common.actions.save': {
    pt: 'Salvar',
    en: 'Save',
    es: 'Guardar',
  },
  'common.actions.cancel': {
    pt: 'Cancelar',
    en: 'Cancel',
    es: 'Cancelar',
  },
  'common.actions.confirm': {
    pt: 'Confirmar',
    en: 'Confirm',
    es: 'Confirmar',
  },
  'common.actions.delete': {
    pt: 'Excluir',
    en: 'Delete',
    es: 'Eliminar',
  },
  'common.actions.edit': {
    pt: 'Editar',
    en: 'Edit',
    es: 'Editar',
  },
  'common.actions.view': {
    pt: 'Visualizar',
    en: 'View',
    es: 'Ver',
  },
  'common.actions.create': {
    pt: 'Criar',
    en: 'Create',
    es: 'Crear',
  },
  'common.actions.add': {
    pt: 'Adicionar',
    en: 'Add',
    es: 'Agregar',
  },
  'common.actions.remove': {
    pt: 'Remover',
    en: 'Remove',
    es: 'Eliminar',
  },
  'common.actions.back': {
    pt: 'Voltar',
    en: 'Back',
    es: 'Volver',
  },
  'common.actions.next': {
    pt: 'Próximo',
    en: 'Next',
    es: 'Siguiente',
  },
  'common.actions.previous': {
    pt: 'Anterior',
    en: 'Previous',
    es: 'Anterior',
  },
  'common.actions.search': {
    pt: 'Buscar',
    en: 'Search',
    es: 'Buscar',
  },
  'common.actions.filter': {
    pt: 'Filtrar',
    en: 'Filter',
    es: 'Filtrar',
  },
  'common.actions.export': {
    pt: 'Exportar',
    en: 'Export',
    es: 'Exportar',
  },
  'common.actions.import': {
    pt: 'Importar',
    en: 'Import',
    es: 'Importar',
  },
  'common.actions.refresh': {
    pt: 'Atualizar',
    en: 'Refresh',
    es: 'Actualizar',
  },
  'common.actions.clear': {
    pt: 'Limpar',
    en: 'Clear',
    es: 'Limpiar',
  },
  'common.actions.close': {
    pt: 'Fechar',
    en: 'Close',
    es: 'Cerrar',
  },
  'common.actions.open': {
    pt: 'Abrir',
    en: 'Open',
    es: 'Abrir',
  },
    'common.tabs.mainData': {
      pt: 'Dados Principais',
      en: 'Main Data',
      es: 'Datos Principales',
    },
    'common.tabs.links': {
      pt: 'Lotes e itens',
      en: 'batch and items',
      es: 'lotes y artículos',
    },
    'common.tabs.history': {
      pt: 'Histórico',
      en: 'History',
      es: 'Historial',
    },
    'common.tabs.history.title': {
      pt: 'Histórico',
      en: 'History',
      es: 'Historial',
    },
    'common.tabs.links.emptyTitle': {
      pt: 'Nenhum vínculo configurado',
      en: 'No relationships configured',
      es: 'Sin vínculos configurados',
    },
    'common.tabs.links.emptyDescription': {
      pt: 'Cadastre vínculos para relacionar este registro a outros elementos do sistema.',
      en: 'Add relationships to link this record with other elements in the system.',
      es: 'Agregue vínculos para relacionar este registro con otros elementos del sistema.',
    },
    'common.tabs.links.cta': {
      pt: 'Gerenciar vínculos',
      en: 'Manage relationships',
      es: 'Gestionar vínculos',
    },
    'common.tabs.history.emptyTitle': {
      pt: 'Histórico em desenvolvimento',
      en: 'History in progress',
      es: 'Historial en desarrollo',
    },
    'common.tabs.history.emptyDescription': {
      pt: 'Em breve você poderá consultar os eventos e alterações deste registro por aqui.',
      en: 'Soon you will be able to review the events and changes for this record here.',
      es: 'Pronto podrá consultar los eventos y cambios de este registro aquí.',
    },
  // ==========================================
  // Common - Fields
  // ==========================================
  'common.fields.id': {
    pt: 'ID',
    en: 'ID',
    es: 'ID',
  },
  'common.fields.createdAt': {
    pt: 'Criado em',
    en: 'Created at',
    es: 'Creado en',
  },
  'common.fields.updatedAt': {
    pt: 'Atualizado em',
    en: 'Updated at',
    es: 'Actualizado en',
  },
  'common.fields.createdBy': {
    pt: 'Criado por',
    en: 'Created by',
    es: 'Creado por',
  },
  'common.fields.updatedBy': {
    pt: 'Atualizado por',
    en: 'Updated by',
    es: 'Actualizado por',
  },
  'common.fields.active': {
    pt: 'Ativo',
    en: 'Active',
    es: 'Activo',
  },
  'common.fields.status': {
    pt: 'Status',
    en: 'Status',
    es: 'Estado',
  },
  'common.actions.download': {
    pt: 'Baixar',
    en: 'Download',
    es: 'Descargar',
  },
  'common.actions.upload': {
    pt: 'Enviar',
    en: 'Upload',
    es: 'Subir',
  },
  'common.actions.print': {
    pt: 'Imprimir',
    en: 'Print',
    es: 'Imprimir',
  },
  'common.actions.copy': {
    pt: 'Copiar',
    en: 'Copy',
    es: 'Copiar',
  },
  'common.actions.duplicate': {
    pt: 'Duplicar',
    en: 'Duplicate',
    es: 'Duplicar',
  },
  'common.actions.submit': {
    pt: 'Enviar',
    en: 'Submit',
    es: 'Enviar',
  },
  'common.actions.reset': {
    pt: 'Resetar',
    en: 'Reset',
    es: 'Restablecer',
  },
  'common.actions.apply': {
    pt: 'Aplicar',
    en: 'Apply',
    es: 'Aplicar',
  },
  'common.actions.continue': {
    pt: 'Continuar',
    en: 'Continue',
    es: 'Continuar',
  },
  'common.actions.finish': {
    pt: 'Finalizar',
    en: 'Finish',
    es: 'Finalizar',
  },

  // ==========================================
  // Common - Messages
  // ==========================================
  'common.messages.loading': {
    pt: 'Carregando...',
    en: 'Loading...',
    es: 'Cargando...',
  },
  'common.messages.saving': {
    pt: 'Salvando...',
    en: 'Saving...',
    es: 'Guardando...',
  },
  'common.messages.processing': {
    pt: 'Processando...',
    en: 'Processing...',
    es: 'Procesando...',
  },
  'common.messages.noData': {
    pt: 'Nenhum registro encontrado',
    en: 'No records found',
    es: 'No se encontraron registros',
  },
  'common.messages.noResults': {
    pt: 'Nenhum resultado encontrado',
    en: 'No results found',
    es: 'No se encontraron resultados',
  },
  'common.messages.error': {
    pt: 'Ocorreu um erro',
    en: 'An error occurred',
    es: 'Ha ocurrido un error',
  },
  'common.messages.success': {
    pt: 'Operação realizada com sucesso',
    en: 'Operation completed successfully',
    es: 'Operación realizada con éxito',
  },
  'common.messages.saved': {
    pt: 'Salvo com sucesso',
    en: 'Saved successfully',
    es: 'Guardado con éxito',
  },
  'common.messages.deleted': {
    pt: 'Excluído com sucesso',
    en: 'Deleted successfully',
    es: 'Eliminado con éxito',
  },
  'common.messages.updated': {
    pt: 'Atualizado com sucesso',
    en: 'Updated successfully',
    es: 'Actualizado con éxito',
  },
  'common.messages.created': {
    pt: 'Criado com sucesso',
    en: 'Created successfully',
    es: 'Creado con éxito',
  },
  'common.messages.confirmDelete': {
    pt: 'Tem certeza que deseja excluir?',
    en: 'Are you sure you want to delete?',
    es: '¿Está seguro que desea eliminar?',
  },
  'common.messages.confirmCancel': {
    pt: 'Tem certeza que deseja cancelar?',
    en: 'Are you sure you want to cancel?',
    es: '¿Está seguro que desea cancelar?',
  },
  'common.messages.unsavedChanges': {
    pt: 'Existem alterações não salvas',
    en: 'There are unsaved changes',
    es: 'Hay cambios sin guardar',
  },
  'common.messages.invalidData': {
    pt: 'Dados inválidos',
    en: 'Invalid data',
    es: 'Datos inválidos',
  },
  'common.messages.requiredField': {
    pt: 'Este campo é obrigatório',
    en: 'This field is required',
    es: 'Este campo es obligatorio',
  },
  'common.messages.notFound': {
    pt: 'Não encontrado',
    en: 'Not found',
    es: 'No encontrado',
  },
  'common.messages.unauthorized': {
    pt: 'Não autorizado',
    en: 'Unauthorized',
    es: 'No autorizado',
  },
  'common.messages.forbidden': {
    pt: 'Acesso negado',
    en: 'Access denied',
    es: 'Acceso denegado',
  },
  'common.messages.sessionExpired': {
    pt: 'Sessão expirada',
    en: 'Session expired',
    es: 'Sesión expirada',
  },
  'common.messages.connectionError': {
    pt: 'Erro de conexão',
    en: 'Connection error',
    es: 'Error de conexión',
  },

  // ==========================================
  // Common - Labels
  // ==========================================
  'common.labels.yes': {
    pt: 'Sim',
    en: 'Yes',
    es: 'Sí',
  },
  'common.labels.no': {
    pt: 'Não',
    en: 'No',
    es: 'No',
  },
  'common.labels.ok': {
    pt: 'OK',
    en: 'OK',
    es: 'OK',
  },
  'common.labels.active': {
    pt: 'Ativo',
    en: 'Active',
    es: 'Activo',
  },
  'common.labels.inactive': {
    pt: 'Inativo',
    en: 'Inactive',
    es: 'Inactivo',
  },
  'common.labels.enabled': {
    pt: 'Habilitado',
    en: 'Enabled',
    es: 'Habilitado',
  },
  'common.labels.disabled': {
    pt: 'Desabilitado',
    en: 'Disabled',
    es: 'Deshabilitado',
  },
  'common.labels.all': {
    pt: 'Todos',
    en: 'All',
    es: 'Todos',
  },
  'common.labels.none': {
    pt: 'Nenhum',
    en: 'None',
    es: 'Ninguno',
  },
  'common.labels.select': {
    pt: 'Selecione',
    en: 'Select',
    es: 'Seleccione',
  },
  'common.labels.selectAll': {
    pt: 'Selecionar Todos',
    en: 'Select All',
    es: 'Seleccionar Todos',
  },
  'common.labels.deselectAll': {
    pt: 'Desmarcar Todos',
    en: 'Deselect All',
    es: 'Deseleccionar Todos',
  },
  'common.labels.optional': {
    pt: 'Opcional',
    en: 'Optional',
    es: 'Opcional',
  },
  'common.labels.required': {
    pt: 'Obrigatório',
    en: 'Required',
    es: 'Obligatorio',
  },
  'common.labels.total': {
    pt: 'Total',
    en: 'Total',
    es: 'Total',
  },
  'common.labels.subtotal': {
    pt: 'Subtotal',
    en: 'Subtotal',
    es: 'Subtotal',
  },
  'common.labels.quantity': {
    pt: 'Quantidade',
    en: 'Quantity',
    es: 'Cantidad',
  },
  'common.labels.price': {
    pt: 'Preço',
    en: 'Price',
    es: 'Precio',
  },
  'common.labels.value': {
    pt: 'Valor',
    en: 'Value',
    es: 'Valor',
  },
  'common.labels.name': {
    pt: 'Nome',
    en: 'Name',
    es: 'Nombre',
  },
  'common.labels.title': {
    pt: 'Título',
    en: 'Title',
    es: 'Título',
  },
  'common.labels.description': {
    pt: 'Descrição',
    en: 'Description',
    es: 'Descripción',
  },
  'common.labels.code': {
    pt: 'Código',
    en: 'Code',
    es: 'Código',
  },
  'common.labels.date': {
    pt: 'Data',
    en: 'Date',
    es: 'Fecha',
  },
  'common.labels.time': {
    pt: 'Hora',
    en: 'Time',
    es: 'Hora',
  },
  'common.labels.startDate': {
    pt: 'Data Início',
    en: 'Start Date',
    es: 'Fecha Inicio',
  },
  'common.labels.endDate': {
    pt: 'Data Fim',
    en: 'End Date',
    es: 'Fecha Fin',
  },
  'common.labels.status': {
    pt: 'Status',
    en: 'Status',
    es: 'Estado',
  },
  'common.labels.type': {
    pt: 'Tipo',
    en: 'Type',
    es: 'Tipo',
  },
  'common.labels.category': {
    pt: 'Categoria',
    en: 'Category',
    es: 'Categoría',
  },
  'common.labels.id': {
    pt: 'ID',
    en: 'ID',
    es: 'ID',
  },
  'common.labels.createdAt': {
    pt: 'Criado em',
    en: 'Created at',
    es: 'Creado en',
  },
  'common.labels.updatedAt': {
    pt: 'Atualizado em',
    en: 'Updated at',
    es: 'Actualizado en',
  },
  'common.labels.createdBy': {
    pt: 'Criado por',
    en: 'Created by',
    es: 'Creado por',
  },
  'common.labels.updatedBy': {
    pt: 'Atualizado por',
    en: 'Updated by',
    es: 'Actualizado por',
  },

  // ==========================================
  // Common - Table/List
  // ==========================================
  'common.table.actions': {
    pt: 'Ações',
    en: 'Actions',
    es: 'Acciones',
  },
  'common.table.noData': {
    pt: 'Nenhum dado disponível',
    en: 'No data available',
    es: 'No hay datos disponibles',
  },
  'common.table.page': {
    pt: 'Página',
    en: 'Page',
    es: 'Página',
  },
  'common.table.of': {
    pt: 'de',
    en: 'of',
    es: 'de',
  },
  'common.table.itemsPerPage': {
    pt: 'Itens por página',
    en: 'Items per page',
    es: 'Ítems por página',
  },
  'common.table.showing': {
    pt: 'Mostrando',
    en: 'Showing',
    es: 'Mostrando',
  },
  'common.table.to': {
    pt: 'até',
    en: 'to',
    es: 'hasta',
  },
  'common.table.entries': {
    pt: 'registros',
    en: 'entries',
    es: 'registros',
  },

  // ==========================================
  // Common - Form
  // ==========================================
  'common.form.enterValue': {
    pt: 'Digite um valor',
    en: 'Enter a value',
    es: 'Ingrese un valor',
  },
  'common.form.selectOption': {
    pt: 'Selecione uma opção',
    en: 'Select an option',
    es: 'Seleccione una opción',
  },
  'common.form.chooseFile': {
    pt: 'Escolher arquivo',
    en: 'Choose file',
    es: 'Elegir archivo',
  },
  'common.form.noFileChosen': {
    pt: 'Nenhum arquivo escolhido',
    en: 'No file chosen',
    es: 'Ningún archivo elegido',
  },

  // ==========================================
  // Common - Validation
  // ==========================================
  'common.validation.required': {
    pt: 'O campo precisa ser preenchido',
    en: 'The field must be filled',
    es: 'El campo debe completarse',
  },
  'common.validation.invalidEmail': {
    pt: 'E-mail inválido',
    en: 'Invalid email',
    es: 'Correo electrónico inválido',
  },
  'common.validation.invalidPhone': {
    pt: 'Telefone inválido',
    en: 'Invalid phone',
    es: 'Teléfono inválido',
  },
  'common.validation.invalidDate': {
    pt: 'Data inválida',
    en: 'Invalid date',
    es: 'Fecha inválida',
  },
  'common.validation.minLength': {
    pt: 'Mínimo de {min} caracteres',
    en: 'Minimum of {min} characters',
    es: 'Mínimo de {min} caracteres',
  },
  'common.validation.maxLength': {
    pt: 'Máximo de {max} caracteres',
    en: 'Maximum of {max} characters',
    es: 'Máximo de {max} caracteres',
  },
  'common.validation.minValue': {
    pt: 'Valor mínimo: {min}',
    en: 'Minimum value: {min}',
    es: 'Valor mínimo: {min}',
  },
  'common.validation.maxValue': {
    pt: 'Valor máximo: {max}',
    en: 'Maximum value: {max}',
    es: 'Valor máximo: {max}',
  },

  // ==========================================
  // Common - Time
  // ==========================================
  'common.time.today': {
    pt: 'Hoje',
    en: 'Today',
    es: 'Hoy',
  },
  'common.time.yesterday': {
    pt: 'Ontem',
    en: 'Yesterday',
    es: 'Ayer',
  },
  'common.time.tomorrow': {
    pt: 'Amanhã',
    en: 'Tomorrow',
    es: 'Mañana',
  },
  'common.time.now': {
    pt: 'Agora',
    en: 'Now',
    es: 'Ahora',
  },
  'common.time.ago': {
    pt: 'atrás',
    en: 'ago',
    es: 'hace',
  },
} as const;

export type I18nKey = keyof typeof i18n;
export type Language = 'pt' | 'en' | 'es';

export default i18n;
